// CNA Skilled Tasks section form field enum
export enum CNASkilledTasksFormField {
  // Task questions
  CNA_SKILLED_TASKS_BATHING_QUESTION = 'cnaSkilledTasks/bathing/question',
  CNA_SKILLED_TASKS_BATHING_NOTES = 'cnaSkilledTasks/bathing/notes',
  CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_QUESTION = 'cnaSkilledTasks/bracesSplintsStockings/question',
  CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_NOTES = 'cnaSkilledTasks/bracesSplintsStockings/notes',
  CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_ADDITIONAL = 'cnaSkilledTasks/bracesSplintsStockings/additional',
  CNA_SKILLED_TASKS_DRESSING_QUESTION = 'cnaSkilledTasks/dressing/question',
  CNA_SKILLED_TASKS_DRESSING_NOTES = 'cnaSkilledTasks/dressing/notes',
  CNA_SKILLED_TASKS_EATING_QUESTION = 'cnaSkilledTasks/eating/question',
  CNA_SKILLED_TASKS_EATING_NOTES = 'cnaSkilledTasks/eating/notes',
  CNA_SKILLED_TASKS_TUBE_FEEDINGS_QUESTION = 'cnaSkilledTasks/tubeFeedings/question',
  CNA_SKILLED_TASKS_TUBE_FEEDINGS_NOTES = 'cnaSkilledTasks/tubeFeedings/notes',
  CNA_SKILLED_TASKS_MEDICATION_QUESTION = 'cnaSkilledTasks/medication/question',
  CNA_SKILLED_TASKS_MEDICATION_NOTES = 'cnaSkilledTasks/medication/notes',
  CNA_SKILLED_TASKS_MOBILITY_QUESTION = 'cnaSkilledTasks/mobility/question',
  CNA_SKILLED_TASKS_MOBILITY_NOTES = 'cnaSkilledTasks/mobility/notes',
  CNA_SKILLED_TASKS_MOBILITY_ADDITIONAL = 'cnaSkilledTasks/mobility/additional',
  CNA_SKILLED_TASKS_MEAL_PREP_QUESTION = 'cnaSkilledTasks/mealPrep/question',
  CNA_SKILLED_TASKS_MEAL_PREP_NOTES = 'cnaSkilledTasks/mealPrep/notes',
  CNA_SKILLED_TASKS_GROOMING_QUESTION = 'cnaSkilledTasks/grooming/question',
  CNA_SKILLED_TASKS_GROOMING_NOTES = 'cnaSkilledTasks/grooming/notes',
  CNA_SKILLED_TASKS_GROOMING_ADDITIONAL = 'cnaSkilledTasks/grooming/additional',
  CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_QUESTION = 'cnaSkilledTasks/skinCareApplication/question',
  CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_NOTES = 'cnaSkilledTasks/skinCareApplication/notes',
  CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_ADDITIONAL = 'cnaSkilledTasks/skinCareApplication/additional',
  CNA_SKILLED_TASKS_SKIN_CARE_QUESTION = 'cnaSkilledTasks/skinCare/question',
  CNA_SKILLED_TASKS_SKIN_CARE_NOTES = 'cnaSkilledTasks/skinCare/notes',
  CNA_SKILLED_TASKS_SKIN_CARE_ADDITIONAL = 'cnaSkilledTasks/skinCare/additional',
  CNA_SKILLED_TASKS_ROM_EXERCISE_QUESTION = 'cnaSkilledTasks/romExercise/question',
  CNA_SKILLED_TASKS_ROM_EXERCISE_NOTES = 'cnaSkilledTasks/romExercise/notes',
  CNA_SKILLED_TASKS_RESPIRATORY_CARE_QUESTION = 'cnaSkilledTasks/respiratoryCare/question',
  CNA_SKILLED_TASKS_RESPIRATORY_CARE_NOTES = 'cnaSkilledTasks/respiratoryCare/notes',
  CNA_SKILLED_TASKS_OXYGEN_THERAPY_QUESTION = 'cnaSkilledTasks/oxygenTherapy/question',
  CNA_SKILLED_TASKS_OXYGEN_THERAPY_NOTES = 'cnaSkilledTasks/oxygenTherapy/notes',
  CNA_SKILLED_TASKS_ORAL_SUCTIONING_QUESTION = 'cnaSkilledTasks/oralSuctioning/question',
  CNA_SKILLED_TASKS_ORAL_SUCTIONING_NOTES = 'cnaSkilledTasks/oralSuctioning/notes',
  CNA_SKILLED_TASKS_BOWEL_FREQUENCY_QUESTION = 'cnaSkilledTasks/bowelFrequency/question',
  CNA_SKILLED_TASKS_BOWEL_FREQUENCY_NOTES = 'cnaSkilledTasks/bowelFrequency/notes',
  CNA_SKILLED_TASKS_BOWEL_HYGIENE_QUESTION = 'cnaSkilledTasks/bowelHygiene/question',
  CNA_SKILLED_TASKS_BOWEL_HYGIENE_NOTES = 'cnaSkilledTasks/bowelHygiene/notes',
  CNA_SKILLED_TASKS_BOWEL_ELIMINATION_QUESTION = 'cnaSkilledTasks/bowelElimination/question',
  CNA_SKILLED_TASKS_BOWEL_ELIMINATION_NOTES = 'cnaSkilledTasks/bowelElimination/notes',
  CNA_SKILLED_TASKS_BOWEL_PROGRAM_QUESTION = 'cnaSkilledTasks/bowelProgram/question',
  CNA_SKILLED_TASKS_BOWEL_PROGRAM_NOTES = 'cnaSkilledTasks/bowelProgram/notes',
  CNA_SKILLED_TASKS_CATHETER_CARE_QUESTION = 'cnaSkilledTasks/catheterCare/question',
  CNA_SKILLED_TASKS_CATHETER_CARE_NOTES = 'cnaSkilledTasks/catheterCare/notes',
  CNA_SKILLED_TASKS_MENSES_QUESTION = 'cnaSkilledTasks/menses/question',
  CNA_SKILLED_TASKS_MENSES_NOTES = 'cnaSkilledTasks/menses/notes',
  CNA_SKILLED_TASKS_URINARY_HYGIENE_QUESTION = 'cnaSkilledTasks/urinaryHygiene/question',
  CNA_SKILLED_TASKS_URINARY_HYGIENE_NOTES = 'cnaSkilledTasks/urinaryHygiene/notes',
  CNA_SKILLED_TASKS_POSITIONING_QUESTION = 'cnaSkilledTasks/positioning/question',
  CNA_SKILLED_TASKS_POSITIONING_NOTES = 'cnaSkilledTasks/positioning/notes',
  CNA_SKILLED_TASKS_TRANSFERS_QUESTION = 'cnaSkilledTasks/transfers/question',
  CNA_SKILLED_TASKS_TRANSFERS_NOTES = 'cnaSkilledTasks/transfers/notes',
  CNA_SKILLED_TASKS_VITALS_PHYSICIAN_QUESTION = 'cnaSkilledTasks/vitalsPhysician/question',
  CNA_SKILLED_TASKS_VITALS_PHYSICIAN_NOTES = 'cnaSkilledTasks/vitalsPhysician/notes',
  CNA_SKILLED_TASKS_VITALS_NURSE_QUESTION = 'cnaSkilledTasks/vitalsNurse/question',
  CNA_SKILLED_TASKS_VITALS_NURSE_NOTES = 'cnaSkilledTasks/vitalsNurse/notes'
}
